import { Enums } from "../common";
import { IOpData } from "../util/interfaces";
import { OpDataType } from ".";
import { OpTechnicalPermission } from "./op-technical-permission";


export class OpTechnicalPermissionData implements IOpData {

    //#region Properties

    public idTechnicalPermissionData: number
    public idTechnicalPermission: number
    public idDataType: number
    public indexNbr: number
    public value: any

    //#endregion


    //#region Navigation Properties

    public dataType: OpDataType = null
    public technicalPermission: OpTechnicalPermission = null

    //#endregion


    //#region Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region IOpData Implementation

    public get idData() { return this.idTechnicalPermission }
    public set idData(idData: number) { this.idTechnicalPermissionData = idData }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    public opState: Enums.OpChangeState;

    public toJSON(compressed: boolean) {
        return {
            ID_TECHNICAL_PERMISSION_DATA: this.idTechnicalPermissionData,
            ID_TECHNICAL_PERMISSION: this.idTechnicalPermission,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false) {
        if (opObj != null) {
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
            this.technicalPermission = opObj._TechnicalPermission != null ? new OpTechnicalPermission(opObj._TechnicalPermission) : null

            this.idTechnicalPermissionData = opObj.ID_TECHNICAL_PERMISSION_DATA
            this.idTechnicalPermission = opObj.ID_TECHNICAL_PERMISSION
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
        } else {
            this.idTechnicalPermission = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    //#endregion


    public toString() {
        return "TechnicalPermissionData [" + this.idTechnicalPermissionData + "]";
    }
}